// extracted by mini-css-extract-plugin
export var hotel_notes = "tourItem-module--hotel_notes--3201b";
export var itinerary_detail = "tourItem-module--itinerary_detail--ca475";
export var schedule_bg_color = "tourItem-module--schedule_bg_color--67ce4";
export var tour_include = "tourItem-module--tour_include--1bab1";
export var tour_not_include = "tourItem-module--tour_not_include--70182";
export var tour_note_body = "tourItem-module--tour_note_body--2179c";
export var tour_period = "tourItem-module--tour_period--61ae7";